import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { guardString } from "@msuite/utils/strings";
import type { Nullable } from "@msuite/utils/types";
import { client } from "@/hono";

/** Props Interface */
interface UseResourceLinksProps {
	projectId?: Nullable<string>;
	ticketId?: Nullable<string>;
}

export function useResourceLinks({ projectId, ticketId }: UseResourceLinksProps) {
	/** Query */
	const query = useQuery({
		queryKey: ["resource-links", guardString(projectId), guardString(ticketId)],
		queryFn: async () => {
			if (ticketId) {
				const response = await client.tickets[":ticketId"]["resource-links"].$get({
					param: { ticketId },
				});
				const data = await responseHandler(response);
				return data.resourceLinks;
			}
			if (!projectId) throw new Error("Project Id or Ticket Id needed");
			const response = await client.projects[":projectId"]["resource-links"].$get({
				param: { projectId },
			});
			const data = await responseHandler(response);
			return data.resourceLinks;
		},
		enabled: !!projectId || !!ticketId,
	});

	return { ...query, resourceLinks: query.data };
}
